import { render, staticRenderFns } from "./InventoryDeskDeal.vue?vue&type=template&id=486bebea&scoped=true"
import script from "./InventoryDeskDeal.vue?vue&type=script&lang=js"
export * from "./InventoryDeskDeal.vue?vue&type=script&lang=js"
import "./InventoryDeskDeal.vue?vue&type=style&index=0&id=486bebea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486bebea",
  null
  
)

export default component.exports